import {forwardRef, Inject, Injectable, OnInit} from "@angular/core";
import {ChatMessageManager} from "../home/chat/model/ChatMessageManager";
import {ChatMemberAndUserManager} from "../home/chat/model/ChatMemberAndUserManager";
import {AlertService} from "./alert.service";
import {ClientService} from "./client.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {SessionService} from "./session.service";
import {TranslateService} from "@ngx-translate/core";
import {ChatMemberAndUser} from "../home/chat/model/ChatMemberAndUser";
import {AlertMessage} from "../directives/AlertMessage";
import {Client, Conversation, Message, Paginator, User} from "@twilio/conversations";
import {Utils} from "../model/Utils";
import {PopupServices} from "./popup.services";
import {EmprezChatMessage} from "../home/chat/model/EmprezChatMessage";


@Injectable()
export class ChatService implements OnInit{
  get nbUnreadMessagesForAllChannels(): number {
    return this._nbUnreadMessagesForAllChannels;
  }


  private _chatMessageManager = new ChatMessageManager();
  private _chatMemberAndUserManager = new ChatMemberAndUserManager();
  private _client: Client;
  // private _publicChannels = new Map<string,Channel>();
  private _userChannels = new Map<string,Conversation>();
  private _channelsSubscribed = new Map<string,Conversation>();
  private _channelsPerSid = new Map<string,Conversation>();
  private _listenersPerSid = new Map<string,Conversation>();
  private _dontShowAlertFromChannel = new Map<string,string>();

 // private _channelDescriptorsPerSid = new Map<string,ChannelDescriptor>();

  // private _availableJobAggregation: AvailableJobAggregation;
  constructor (
    @Inject(forwardRef(() => AlertService)) private alertService: AlertService,
    @Inject(forwardRef(() => ClientService)) private clientService: ClientService,
    @Inject(forwardRef(() => NgbModal)) private modalService: NgbModal,
    @Inject(forwardRef(() => PopupServices)) private popupServices: PopupServices,
    @Inject(forwardRef(() => SessionService)) public session: SessionService,
    @Inject(forwardRef(() => TranslateService)) private translate: TranslateService
  ) {



  }

  /*
  public hasChannelDescriptor(channelSid: string){
    return true;
    // return this._channelDescriptorsPerSid.has(channelSid);
  }

  public getChannelDescriptor(channelSid: string){
    return null;
      // return this._channelDescriptorsPerSid.get(channelSid);
  }

   */

  public get client(){
    return this._client;
  }
  public resetClient(){
    this._client = null;
  }

  /*
  public get publicChannels():Array<Conversation>{

    const res = new Array<Conversation>();

    for (const tmp of Array.from(this._publicChannels.values())){
      if (tmp.isPrivate === false){
        if (!this._channelsSubscribed.has(tmp.sid)){
          res.push(tmp);
        }
      }
    }
    return res;
  }
 */

  public get userChannels():Array<Conversation>{
    return Array.from(this._userChannels.values());
  }

  /*
  sendMessage(event){
    console.log('Trying to send message: ' + event);

    if (this._currentChannel && event && event.trim().length>0){
      this._currentChannel.sendMessage(event).then((value)=>{
        // this.textMessage = '';

      });
    }
  }

  public get currentChannel(){
    return this._currentChannel;
  }

   */

  public updateMembersStatus(channelSid: string){
    this.client.getConversationBySid(channelSid).then((conversation)=>{
        conversation.getParticipants().then((participants)=>{
          for (const member of participants) {
            this._chatMemberAndUserManager.updateMember(channelSid, member);
          }
        });
    });
    /*
    if (this.client.hasChannelDescriptor(channelSid)) {
      this.getChannelDescriptor(channelSid).getChannel().then((channel) => {
        channel.getMembers().then((members) => {
          for (const member of members) {
            this._chatMemberAndUserManager.updateMember(channel.sid, member);
          }
        })
      })
    }
     */

  }

  public getConversationBySid(sid: string) :Conversation{
    return this._channelsPerSid.get(sid);
  }

  /*
  public deleteChannel(channelSid: string):Promise<Conversation>{
    const channel = this._channelsPerSid.get(channelSid);
    // this._channelDescriptorsPerSid.delete(channelSid);
    this._chatMemberAndUserManager.removeChannel(channelSid);
    return channel.delete();
  }

  public leaveChannel(channelSid: string):Promise<Conversation>{
    const channel = this._channelsPerSid.get(channelSid);
    return channel.leave();
  }

  public joinChannel(channelSid: string):Promise<Conversation>{
    const channel = this._channelsPerSid.get(channelSid);
    return channel.join();

  }

   */



  public getCurrentMembers(channelSid: string):ChatMemberAndUser[]{
     return this._chatMemberAndUserManager.sortMembers(channelSid);
  }

  public getMemberSIdForChannelAndUserIdentify(channelSid: string, userIdentity: string): string{
    for (const bean of this.getCurrentMembers(channelSid)){
      if (bean.user.identity === userIdentity){
        // console.log('for ' + userIdentity + ' memberId: ' + bean.member.sid);
        return bean.member.sid;
      }
    }
    return null;
  }

  public getCurrentMessages(channelSid: string):Map<string,Message[]>{
    return this._chatMessageManager.retrieveMessagePerDate(channelSid);
  }

  ngOnInit__OLD(): void {
    if (this.session.chatServiceIsInitialized===true){
      console.log('Init has been done!');
      if (this.session.userInfo.isAbleToChat===true && this.session.shouldRenewToken === true){
        this._renewingToken();
      }
      return;
    }
    if (this.session.userInfo.isAbleToChat){
      console.log('Initializing the ChatService');
      this.retrieveChatToken();
    }else{
      console.log('ChatService is not initialized, user: ' + this.session.userInfo.user.username + ' has no access');
      this.session.chatServiceIsInitialized = true;
    }
  }

  ngOnInit(): void {
    if (this.session.userInfo.isAbleToChat){
      if (Utils.isNullOrUndefined(this._client)){
        console.log('Initializing the ChatService');
        this.retrieveChatToken();
      }else {
        console.log('Chat Connection State is ' + this._client.connectionState);
        if (this.session.chatServiceIsInitialized==false){
          console.log('RE-Initializing the ChatService');
          this.retrieveChatToken();
        }
        /*
        if (Utils.isNullOrUndefined(this._client.connectionState)){
          console.log('Chat Connection State is ' + this._client.connectionState);
          if (this._client.connectionState==="connecting"){
            return;
          }
          if (this._client.connectionState==="disconnected" ||
            this._client.connectionState==="disconnecting" ||
            this._client.connectionState==="unknown" ||
            this._client.connectionState==="denied" ||
            this._client.connectionState==="error" ){

          //  this.retrieveChatToken();

             return;

            // "" | "disconnecting" | "disconnected" | "connecting" | "connected" | "" | "";

          }
        }else{
          console.log('No connectionState');
         // this.retrieveChatToken();
          return;
        }

         */
      }
    }else{
      console.log('ChatService is not initialized, user: ' + this.session.userInfo.user.username + ' has no access');
      this.session.chatServiceIsInitialized = true;
    }
  }


  close(){
    if (this.session.chatServiceIsInitialized){
      console.log('closing chatService.');
       this._client.removeAllListeners();
       return this._client.shutdown();
    }
  }


  // public addMember(channelSid: string, members:string[]){
  //   for (const member of members){
  //     this._channelsPerSid.get(channelSid).add()
  //   }
  // }

  private _blockAddChannel = false;

  public get blockAddChanel(){
    return this._blockAddChannel;
  }

  public set blockAddChanel(b){
    this._blockAddChannel = b;
  }




  private _nbUnreadMessagesForAllChannels = 0;

  private _mapUnread = new Map<string,number>();




  private _loadMessage(paginator:Paginator<Conversation>,promisesPaginator: Array<Promise<any>>, promisesMessages: Array<Promise<any>>){

    console.log('Loading '+ paginator.items.length + ' conversations.')
    for (const bean of paginator.items){
      promisesMessages.push(
          bean.getUnreadMessagesCount().then((nb)=>{
            this._mapUnread.set(bean.sid,nb);
            // console.log(bean.sid + ' has unconsumedMessages ' + nb);
          }).catch((reason)=>{
            console.log(bean.friendlyName + ' getUnreadMessages ',reason);
          })
      );
    }

    if (paginator.hasNextPage){
      promisesPaginator.push(paginator.nextPage().then((res)=>{
        this._loadMessage(res,promisesPaginator,promisesMessages);
      }));
    }
  }



  private _retrieveSubscribedConversations(){
    console.log('Retrieve Subscribed Conversations');
    if (this.client){
      this.client.getSubscribedConversations().then((paginator)=>{
        //this.userChannels.length = 0;
        console.log('Loading '+ paginator.items.length + ' conversations.')
        const promisesPaginator = new Array<Promise<any>>();
        const promisesMessages = new Array<Promise<any>>();
        this._loadMessage(paginator,promisesPaginator,promisesMessages);

        Promise.all(promisesPaginator).then((res)=>{
          console.log(''+ promisesMessages.length + ' conversations to load');

          Promise.all(promisesMessages).then(()=>{
            this._nbUnreadMessagesForAllChannels = 0;
            for (const sid of Array.from(this._mapUnread.keys())){
              this._nbUnreadMessagesForAllChannels += this._mapUnread.get(sid);
            }
            console.log('Nb message unread: ' + this._nbUnreadMessagesForAllChannels);

          });


        });

          /*
          for (const bean of paginator.items){
            promises.push(
                bean.getUnreadMessagesCount().then((nb)=>{
                  this._mapUnread.set(bean.sid,nb);
                  // console.log(bean.sid + ' has unconsumedMessages ' + nb);
                }).catch((reason)=>{
                  console.log(bean.friendlyName + ' getUnreadMessages ',reason);
                })
            );
          }

           */



      }).catch((reason)=>{
        console.log('_retrieveSubscribedConversations',reason);
      });
    }

  }

  retrieveChatToken(){
    this.clientService.getChatToken().then(
      (res) => {
        if (res.success) {

          /**
           *
           Migration to conversations ?
           Conversations.Client.create(token).then(client => {
              // Use client
            });

           */


          // console.log('getChatToken is ' + JSON.stringify(res.data, null, 1));
          this._client = new Client(res.data);
          this._client.removeAllListeners();
          this.client.on('stateChanged',(state)=>{
            if (state === 'initialized'){
              console.log('Conversations has been initialized. ' + this.client.connectionState)
              this.session.chatServiceIsInitialized = true;

              this._retrieveSubscribedConversations();
            }
          });

          this.client.on('connectionError',(errors)=>{
            console.log('ConnectionError ',errors);
          });


          this.client.on('connectionStateChanged',(state)=>{
            console.log('connectionStateChanged ',state);
          });


          this.client.on('conversationAdded',(conversation)=>{
            // console.log('ConversationAdded ' + conversation.friendlyName,conversation);
            if (this.blockAddChanel===false){
              this._addChannel(conversation);
              // this._retrieveChannelDescriptors();
            }else{
              console.log('blocking add chanel')
            }
          });

          this.client.on('conversationJoined',(conversation)=>{
            // console.log('conversationJoined ' + conversation.friendlyName,conversation);
            this._prepareChannel(conversation);
          });

          this.client.on('conversationLeft',(conversation)=>{
            // console.log('conversationLeft ' + conversation.friendlyName,conversation);
            this._removeChannel(conversation);
          });
          this.client.on('conversationRemoved',(conversation)=>{
            // console.log('conversationRemoved ' + conversation.friendlyName,conversation);
            this._deleteChannel(conversation);
          });
          this.client.on('conversationUpdated',(conversation)=>{
            console.log('conversationUpdated ' + conversation.conversation.friendlyName ,conversation.updateReasons);
          });


          this._client.on('tokenExpired',()=>{
            console.log('tokenExpired');
          });

          this._client.on('tokenAboutToExpire',()=>{
            console.log('tokenAboutToExpire ');
            this._renewingToken();
          });


          /*
          TwilioChat.create(res.data).then( client =>{
            this._client = client;
            this.session.chatServiceIsInitialized = true;
            this._client.addListener('channelInvited', (channel)=> {
              console.log('Event Invited to channel ' + channel.friendlyName);
              channel.join().then((value)=>{
                this._addChannel(channel);
                this._retrieveChannelDescriptors();
                //this._retrieveChannels();
              });
            });
            this._client.addListener('channelAdded', (channel)=> {
              console.log('Event Channel Added ' + channel.friendlyName + ' status: ' + channel.status);
              // if ('joined'===channel.state.status){
              //   if (this._client.user.identity === channel.createdBy){
              //     console.log('Adding Channel created by me!');
              //   }
              // }
              if (this.blockAddChanel===false){
                this._addChannel(channel);
                this._retrieveChannelDescriptors();
              }else{
                console.log('blocking add chanel')
              }
//              this._retrieveChannels();
            });
            this._client.addListener('channelUpdated', (channel)=> {
              console.log('Event Channel Updated ' + channel.friendlyName + ' status: ' + channel.status);
              this._retrieveChannelDescriptors();
            });
            this._client.addListener('channelLeft', (channel)=> {
              console.log('Event Channel Left ' + channel.friendlyName);
              this._removeChannel(channel);
            });
            this._client.addListener('channelRemoved', (channel)=> {
              console.log('Event Channel Removed ' + channel.friendlyName);
              this._deleteChannel(channel);
            });

            this._client.addListener('tokenAboutToExpire',()=>{
                this._renewingToken();
            });
            this._retrieveChannelDescriptors();
            // this._retrieveChannels();
          });
          */
        } else {
          console.log('Error ' + res.description + ' ' + res.data);
        }
      }
    );

  }

  private _renewingToken(){
    console.log('renewing token!');
    this.clientService.getChatToken().then((res)=>{
      if (res.success){
        this._client.updateToken(res.data);
        console.log('token should have been renewed.');
        this.session.setTokenRenewed();
      }
    });
  }

  public verifyIfShouldBeMemberToNewPublicChannels(){
    /*
    for (const publicChannelNotSubscribed of this.publicChannels ){
      publicChannelNotSubscribed.join().then((channel)=>{
        console.log('Just joined new Public Channel: ' + channel.friendlyName);
        this._addChannel(channel);
        // this._channelsSubscribed.set(channel.sid,channel);
      });
    }

     */
    /*
    for (const channelDescriptor of Array.from(this._channelDescriptorsPerSid.values())){
      if (this._channelsSubscribed.has(channelDescriptor.sid)===false){
        console.log('Public channel: ' + channelDescriptor.friendlyName + ' is not subscribed.');
        channelDescriptor.getChannel().then((channel)=>{
          channel.join().then((channel)=>{
            console.log('Just joined new Public Channel: ' + channel.friendlyName);
            this._addChannel(channel);
            // this._channelsSubscribed.set(channel.sid,channel);
          });
        });
      }
    }

     */
  }

  public createNewChannel(channelName:string,isPrivate: boolean, identities:string[]){
    // }
    this.blockAddChanel = true;
    // this.chatService.blockAddChanel = true;
    this._client.createConversation({
      friendlyName:channelName,
      // isPrivate: isPrivate,
    }).then((channel)=>{
      console.log('Channel Created!, Invitation not done.');
      this.blockAddChanel = false;
      for (const identity of identities){
        channel.add(identity).then(()=>{
            console.log('identify added: ' + identity);
            ;
        });
      }
      channel.add(this._client.user.identity).then(()=>{
        console.log('Added my self as a member!');
        this._addChannel(channel);
        ;
      });

      // channel.add()
      // this.chatService.blockAddChanel = false;
      /*
      console.log('Launching Invitation.');
      this.invite(channel).then(()=>{
        console.log('Invitation sent');
        this.activeModal.close(channel.sid);
      });

       */

    },()=>{
      console.log('Failure adding channel');
      this.blockAddChanel = false;

    }).catch(()=>{
      console.log('Failure adding channel, exception');
      this.blockAddChanel = false;
    });

  }



  public createNewChannelNG(channelName:string,isPrivate: boolean, identities:string[]){
    // }
    // new <T>(executor: (resolve: (value?: T | PromiseLike<T>) => void, reject: (reason?: any) => void) => void): Promise<T>;


    return new Promise<boolean>( (resolve,reject)=>{
      this.blockAddChanel = true;
      // this.chatService.blockAddChanel = true;
      // await this._client.createChannel({friendlyName:channelName, isPrivate: isPrivate});

      this._client.createConversation({
        friendlyName:channelName,
        // isPrivate: isPrivate,
      }).then((channel)=>{
        console.log('Channel Created!, Invitation not done.');
        this.blockAddChanel = false;
        const _allPromises = new Array();
        for (const identity of identities){
          console.log('identify adding: ' + identity);
          if (identity === this.session.userInfo.user.employeeCode){
            console.log('This is me, not adding me!');
          }else{
            _allPromises.push(channel.add(identity));
          }
        }


        Promise.all(
          _allPromises
        ).then(()=>{
          console.log('Promises done.');
          channel.add(this._client.user.identity).then(()=>{
            console.log('Added my self as a member!');
            this._addChannel(channel);
            resolve(true);
          });
        });
      },()=>{
        console.log('Failure adding channel');
        this.blockAddChanel = false;
        reject();
      }).catch(()=>{
        console.log('Failure adding channel, exception');
        this.blockAddChanel = false;
        reject();
      });

    });



  }

  public get chatUser():User{
    return this._client.user;
  }

  public isItMe(identity: string){
    if (this._client.user.identity === identity){
      return true;
    }
    return false;
  }

  private _addChannel(channel: Conversation){
    // console.log('_addChannel ',channel);

    // channelDescriptor.getChannel().then((channel)=>{
      this._channelsPerSid.set(channel.sid,channel);
        channel.getParticipants().then((members)=>{
            let found = false;
            for (let member of members){
              if (member.identity===this._client.user.identity){
                found = true;
                break;
              }
            }
            if (found){
              // console.log('Subscribed Channel: ' + channel.friendlyName + ' ' + channel.lastReadMessageIndex);
              this._userChannels.set(channel.sid,channel);
              this._channelsSubscribed.set(channel.sid,channel);
              this._prepareChannel(channel);
            }
        },(reason)=>{
          console.log('Failure ' + channel.friendlyName);
          if (channel.createdBy === this._client.user.identity){
            console.log('Failure ' + channel.friendlyName + ' but i am the owner.');
            this._userChannels.set(channel.sid,channel);
          }
        }).catch(()=>{
          console.log('Exception ' + channel.friendlyName);
        });


    // });


  }

  private _removeChannel(channel: Conversation){
    this._removeAllListeners(channel);
    this._userChannels.delete(channel.sid);
    this._channelsSubscribed.delete(channel.sid)
    // this._userChannels.clear();
    // this._channelsSubscribed.clear();
  }

  private _deleteChannel(channel:Conversation){
    this._removeChannel(channel);
    this._channelsPerSid.delete(channel.sid);
    // this._publicChannels.delete(channel.sid);
    this._chatMemberAndUserManager.removeChannel(channel.sid);
    // this._channelDescriptorsPerSid.delete(channel.sid);
  }
   /*
  private _retrieveChannelDescriptors(){
    // this._publicChannels.clear();
    this._client.getPublicChannelDescriptors().then((paginator) =>{
      this._retrieveChannelDescriptorPage(paginator);
      while (paginator.hasNextPage){
        paginator.nextPage().then((descriptors)=>{
          this._retrieveChannelDescriptorPage(descriptors);
        });
      }
      while (paginator.hasPrevPage){
        paginator.prevPage().then((descriptors)=>{
          this._retrieveChannelDescriptorPage(descriptors);
        });
      }
    });
    this._client.getUserChannelDescriptors().then((paginator) => {
      this._retrieveChannelDescriptorPage(paginator);
      while (paginator.hasNextPage){
        paginator.nextPage().then((descriptors)=>{
          this._retrieveChannelDescriptorPage(descriptors);
        });
      }
      while (paginator.hasPrevPage){
        paginator.prevPage().then((descriptors)=>{
          this._retrieveChannelDescriptorPage(descriptors);
        });
      }
    });

  }

  private _retrieveChannelDescriptorPage(paginator:Paginator<ChannelDescriptor>){
    for (let i=0; i<paginator.items.length; i++) {
      var channelDescriptor = paginator.items[i];
      // console.info("Channel Descriptor: " + channelDescriptor.friendlyName);
      this._channelDescriptorsPerSid.set(channelDescriptor.sid,channelDescriptor);
    }
  }
     */


  private _removeAllListeners(channel: Conversation){
    // channel.removeListener()
    channel.removeAllListeners('messageAdded');
    channel.removeAllListeners('messageRemoved');
    channel.removeAllListeners('messageUpdated');
    channel.removeAllListeners('participantJoined');
    channel.removeAllListeners('participantLeft');
    channel.removeAllListeners('participantUpdated');
    channel.removeAllListeners('removed');
    channel.removeAllListeners('updated');
    channel.removeAllListeners('typingStarted');
    channel.removeAllListeners('typingEnded');

    this._listenersPerSid.delete(channel.sid);

  }


  public dontShowAlertFrom(channelSid: string){
    this._dontShowAlertFromChannel.set(channelSid,channelSid);
  }
  public showAlertFrom(channelSid: string){
    if (this._dontShowAlertFromChannel.has(channelSid)){
      this._dontShowAlertFromChannel.delete(channelSid);
    }
  }

  public retrieveAuthorFriendlyName(channelSid:string, messageAuthor: string):string{
    return this._chatMemberAndUserManager.getFriendlyNameOf(channelSid,messageAuthor);

  }

  public _displayMessageAlert(message: Message){
    if (!this._dontShowAlertFromChannel.has(message.conversation.sid)){
      console.log('Calling the Alert Service for a chat message');
      const emprezChatMessage = new EmprezChatMessage();
      const msg = new AlertMessage();
      msg.type='chat';
      msg.chatType = true;

      // const authorFriendlyName = this._chatMemberAndUserManager.getFriendlyNameOf(message.channel.sid,message.author);
      this.client.getConversationBySid(message.conversation.sid).then((conversation)=>{
         conversation.getParticipantByIdentity(message.author).then((participant)=>{

           participant.getUser().then((user)=>{
             msg.message = this.translate.instant('NewChatFrom',{body: message.body, from: user.friendlyName, channel: message.conversation.friendlyName})
             msg.chatChannelId = message.conversation.sid;

             emprezChatMessage.body = message.body;
             emprezChatMessage.fromName = user.friendlyName;
             emprezChatMessage.channelName = message.conversation.friendlyName;

             emprezChatMessage.chatChannelId = message.conversation.sid;

             // this.alertService.newChat(msg);
             this.popupServices.chat(emprezChatMessage)
             console.log('message/alert sent!');
           })


         });
      });
      // const authorFriendlyName = this.retrieveAuthorFriendlyName(message.conversation.sid,message.author);

      /*
      if (this.getChannelDescriptor(message.conversation.sid).membersCount<=2){
        msg.message = this.translate.instant('NewPrivateChatFrom',{body: message.body, from: authorFriendlyName})
      }else{

       */
      //}
      // msg.message = 'New Message in ' + message.channel.friendlyName + ' from  ' + message.author + ' ' + message.body;

    }else{
      console.log('chat alert blocked.');
    }
  }

  public _addListeners(channel:Conversation){


    if (!this._listenersPerSid.has(channel.sid)){
      // console.log('Adding Listeners for ' + channel.friendlyName);
      this._listenersPerSid.set(channel.sid,channel);

      channel.addListener('removed',(message) =>{
        // console.log('Conversation updated ' + message.friendlyName, message);
      });
      channel.addListener('updated',(message) =>{
        // console.log('Conversation updated ' + message.conversation.friendlyName, message.updateReasons);
        // channel.lastReadMessageIndex
      });


      channel.addListener('messageAdded',(message) =>{
         console.log('Conversation updated ' + message.conversation.friendlyName, message);
        const res = this._chatMessageManager.addMessage(channel.sid,message);
        if (res===true){
          this._displayMessageAlert(message);
        }
      });
      channel.addListener('messageRemoved',(message) =>{
        this._chatMessageManager.removeMessage(channel.sid,message);
        // console.log('Message removed ', message);
        // this._displayMessageAlert(message);
      });

      channel.addListener('messageUpdated',(message) =>{
        // this._chatMessageManager.removeMessage(channel.sid,message);
        console.log('Message updated ', message);
        // this._displayMessageAlert(message);
      });

      channel.addListener('participantJoined',(member)=>{
        this._chatMemberAndUserManager.addNewMember(channel.sid,member);
      });
      channel.addListener('participantLeft',(member)=>{
        console.log(member.identity + ' has left the channel.');
        this._chatMemberAndUserManager.removeMember(channel.sid,member);
      });
      channel.addListener('participantUpdated',(member)=>{
        console.log(member.participant.identity + ' info Updated.');
        this._chatMemberAndUserManager.updateMember(channel.sid,member.participant);
      });
      /*
      channel.addListener('typingStarted',(member)=>{
        console.log(member.identity + ' started typing.');
        this._chatMemberAndUserManager.memberStartTyping(channel.sid,member);
      });
      channel.addListener('typingEnded',(member)=>{
        console.log(member.identity + ' ended typing.');
        this._chatMemberAndUserManager.memberEndTyping(channel.sid,member);
      });

       */



      /*
      channel.on('memberUpdated', function(member) {
        console.log(member.identity + ' info memberUpdated.');
        // note this method would use the provided information
        // to render this to the user in some way
        this._client.updateMemberMessageReadStatus(member.identity,
          member.lastConsumedMessageIndex,
          member.lastConsumptionTimestamp);
      });

       */

    }
  }

  private _prepareChannel(channel: Conversation){
     // console.log('Preparing Channel ' + channel.friendlyName);
    this._addListeners(channel);
  }

  private _buildChannelName(channel:Conversation):string{
    let res = '';
    if (channel){

        const members = this.getCurrentMembers(channel.sid);
        if (members.length<=2){
          for (const bean of members){
            if (bean.user){
              if (this.isItMe(bean.user.identity)){
                continue;
              }
              res = bean.user.friendlyName;
              break;
            }
          }
        }else{
          res = channel.friendlyName;
        }

    }
    return res;
  }



}

